/* For client account company */
export interface ClientAccountCompany {
    id?: number | null;
    company_name?: string;
    account_name?: string;
    sort_code?: string;
    account_no?: string;
}

// to single object maping
export const mapClientAccountCompany = (data: any): ClientAccountCompany => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const company: ClientAccountCompany = {
        id: data.id,
        company_name: data.company_name,
        account_name: data.account_name,
        sort_code: data.sort_code,
        account_no: data.account_no
    }

    return company;
}

// maping list objects
export const mapClientAccountCompanies = (data: any[]): ClientAccountCompany[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapClientAccountCompany);
}

/* ***************************************************************************** */

/* For client account */
export interface ClientAccountType {
    id?: number;
    account_for?: 'Cash' | 'Credit';
    account_type: 'My account' | 'Company account';
    project_id?: number;
    company_id?: number | null;
    cash?: 'In' | 'Out';
    date?: string;
    title?: string;
    amount?: number;
    file?: string | null;
    file_extension?: string | null;
    is_settled?: 1 | 0;
    created_by?: number;
}

// to single object maping
export const mapClientAccountType = (data: any): ClientAccountType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const account: ClientAccountType = {
        id: data.id,
        account_for: data.account_for,
        account_type: data.account_type,
        project_id: data.project_id,
        company_id: data.company_id,
        cash: data.cash,
        date: data.date,
        title: data.title,
        amount: data.amount,
        file: data.file,
        file_extension: data.file_extension,
        is_settled: data.is_settled,
        created_by: data.created_by,
    }

    return account;
}

// maping list objects
export const mapClientAccountTypes = (data: any[]): ClientAccountType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    
    return data.map(mapClientAccountType);
}